module.exports = __webpack_public_path__ + "static/img/A.b56dbbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/simba/A.png
// module id = i0J5
// module chunks = 0